import "../css/tailwind.css";
import DOMReady from "./utils/DOMReady";
import YTLoader from "./utils/YTLoader";
import lazyLoad from "./modules/lazy-load";
import svgLoader from "./modules/svg-loader";
import { initGalleryLightbox } from "./modules/gallery-lightbox";
import "../css/main.scss";
import "./global/header";
DOMReady(() => {
    YTLoader.init();
    lazyLoad.init();
    svgLoader.init();
    initGalleryLightbox();
});
